<div class="tooltip-wrapper" [ngClass]="{ 'santa-block': fullWidth }">
  <div #tooltipContainerRef class="santa-h-full santa-flex">
    <ng-content></ng-content>
  </div>

  <div
    *ngIf="state.enableTooltip"
    [class]="['tooltip-content', tooltipPositionConfig[tooltipPosition], tooltipOriginConfig[tooltipOrigin]]"
    [style.--offset.px]="tooltipOffset"
    [style.--arrow-position.px]="state.arrowPosition"
    [class.santa-visible]="state.tooltipIsOpen"
  >
    <div #tooltipContentRef class="tooltip-inner">
      <ng-container *ngIf="tooltipContent as tooltipContentRef">
        <ng-container *polymorpheusOutlet="tooltipContentRef as item; context: tooltipContentContext | contextToImplicit">
          <p [style.width]="width" [class.santa-whitespace-nowrap]="!wrapText" class="santa-m-0 santa-typo-additional santa-text-black-100">
            {{ item }}
          </p>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
